// src/features/portfolio-optimization-tools/multi-asset-portfolio-optimizer/components/sleeveColors.ts
//
// Institutional colour palette mapped strictly to the backend ACTIVE_SLEEVES
// (see backend/app/domain/portfolio_optimization/constants.py). Keeping the
// mapping in one place means the donut, the legend and the holdings table all
// speak the same colour language.

export const SLEEVE_COLORS: Record<string, string> = {
    equities: '#2563eb', // Deep Blue
    etf: '#7c3aed', // Purple
    commodities: '#d97706', // Amber
    reits: '#059669', // Emerald
    cryptocurrencies: '#db2777', // Pink
    fx: '#475569', // Slate
};

const FALLBACK = '#94a3b8';

/** Colour for a sleeve id; falls back to a neutral slate for unknown keys. */
export const sleeveColor = (sleeve: string): string =>
    SLEEVE_COLORS[sleeve] ?? FALLBACK;

/** Human-friendly label for a sleeve id (capitalised, no underscores). */
export const sleeveLabel = (sleeve: string): string =>
    sleeve
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
